import React from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { Pricing } from './pages/Pricing';
import { AdditionalCosts } from './pages/AdditionalCosts';
import { Contact } from './pages/Contact';
import { Industries } from './pages/Industries';
import { Crm } from './pages/Crm';
import { useHashRoute } from './hooks/useHashRoute';
export function App() {
  const route = useHashRoute();
  return <div className="min-h-screen w-full bg-white font-sans text-gray-900 selection:bg-red-200 selection:text-red-900" data-id="element-0" data-mp="2mndpmel5m0uj">
      <AnnouncementBar data-id="element-1" data-mp="31ctfztgrw49p" />
      <Navbar route={route} data-id="element-2" data-mp="2wka18t6cn33b" />
      <main data-id="element-3" data-mp="2wiyy8vkq9zd9">
        {route === 'pricing' && <Pricing data-id="element-4" data-mp="2whx9joashed2" />}
        {route === 'additionalCosts' && <AdditionalCosts data-id="element-5" data-mp="28tmg367fagyt" />}
        {route === 'contact' && <Contact data-id="element-6" data-mp="28sbar1ybx15l" />}
        {route === 'industries' && <Industries data-id="element-7" data-mp="23w4e5zrtp20b" />}
        {route === 'crm' && <Crm data-id="element-8" data-mp="23v2uj6wqr76z" />}
        {route === 'home' && <Home data-id="element-9" data-mp="3ik7ekc2063oj" />}
      </main>
      <Footer data-id="element-10" data-mp="3iiwfuqnezm4a" />
    </div>;
}